/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';

import {
  ApiAccordionFromJSONTyped,
  ApiAdTileSetFromJSONTyped,
  ApiBannerFromJSONTyped,
  ApiBannerCarouselFromJSONTyped,
  ApiNoContentFromJSONTyped,
  ApiProductCarouselFromJSONTyped,
  ApiShopNavFromJSONTyped,
  ApiSimpleItemCarouselGridFromJSONTyped,
  ApiSimpleItemCarouselItemFromJSONTyped,
  ApiStandardBannerFromJSONTyped,
  ApiStandardBannerCarouselFromJSONTyped,
  ApiStandardBlogCardFromJSONTyped,
  ApiStandardCardFromJSONTyped,
  ApiStandardContentBlockFromJSONTyped,
  ApiStandardNonSkuFromJSONTyped,
  ApiStandardPlaceholderFromJSONTyped,
  ApiStandardSiteWideBannerFromJSONTyped,
  ApiStandardSkuFromJSONTyped,
  ApiTileSetFromJSONTyped,
} from './';

/**
 *
 * @export
 * @interface ApiComponent
 */
export interface ApiComponent {
  /**
   *
   * @type {ApiAnalytics}
   * @memberof ApiComponent
   */
  analytics: ApiAnalytics;
  /**
   *
   * @type {string}
   * @memberof ApiComponent
   */
  id: string;
  /**
   *
   * @type {ApiInstrumentation}
   * @memberof ApiComponent
   */
  instrumentation?: ApiInstrumentation;
  /**
   *
   * @type {string}
   * @memberof ApiComponent
   */
  type: string;
}

export function ApiComponentFromJSON(json: any): ApiComponent {
  return ApiComponentFromJSONTyped(json, false);
}

export function ApiComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiComponent {
  if (json === undefined || json === null) {
    return json;
  }
  if (!ignoreDiscriminator) {
    if (json['type'] === 'Accordion') {
      return ApiAccordionFromJSONTyped(json, true);
    }
    if (json['type'] === 'AdTileSet') {
      return ApiAdTileSetFromJSONTyped(json, true);
    }
    if (json['type'] === 'Banner') {
      return ApiBannerFromJSONTyped(json, true);
    }
    if (json['type'] === 'BannerCarousel') {
      return ApiBannerCarouselFromJSONTyped(json, true);
    }
    if (json['type'] === 'NoContent') {
      return ApiNoContentFromJSONTyped(json, true);
    }
    if (json['type'] === 'ProductCarousel') {
      return ApiProductCarouselFromJSONTyped(json, true);
    }
    if (json['type'] === 'ShopNav') {
      return ApiShopNavFromJSONTyped(json, true);
    }
    if (json['type'] === 'SimpleItemCarouselGrid') {
      return ApiSimpleItemCarouselGridFromJSONTyped(json, true);
    }
    if (json['type'] === 'SimpleItemCarouselItem') {
      return ApiSimpleItemCarouselItemFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardBanner') {
      return ApiStandardBannerFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardBannerCarousel') {
      return ApiStandardBannerCarouselFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardBlogCard') {
      return ApiStandardBlogCardFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardCard') {
      return ApiStandardCardFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardContentBlock') {
      return ApiStandardContentBlockFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardNonSku') {
      return ApiStandardNonSkuFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardPlaceholder') {
      return ApiStandardPlaceholderFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardSiteWideBanner') {
      return ApiStandardSiteWideBannerFromJSONTyped(json, true);
    }
    if (json['type'] === 'StandardSku') {
      return ApiStandardSkuFromJSONTyped(json, true);
    }
    if (json['type'] === 'TileSet') {
      return ApiTileSetFromJSONTyped(json, true);
    }
  }
  return {
    analytics: ApiAnalyticsFromJSON(json['analytics']),
    id: json['id'],
    instrumentation: !exists(json, 'instrumentation')
      ? undefined
      : ApiInstrumentationFromJSON(json['instrumentation']),
    type: json['type'],
  };
}

export function ApiComponentToJSON(value?: ApiComponent | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    analytics: ApiAnalyticsToJSON(value.analytics),
    id: value.id,
    instrumentation: ApiInstrumentationToJSON(value.instrumentation),
    type: value.type,
  };
}
